<template>
  <v-container
    class="pa-0 mt-md-2"
  >
    <v-card
      flat
      tile
      class="pa-3"
    >
      <v-toolbar
        flat
      >
        <v-btn
          icon
          to="/eleave/list"
        >
          <v-icon>{{ mdiArrowLeft }}</v-icon>
        </v-btn>
        <v-toolbar-title>
          {{ $t('eLeave.ApplyALOrAbsence') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-form ref="feriasForm">
        <v-row>
          <v-col
            cols="12"
            md="8"
          >
            <v-row dense>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.approver"
                  :label="$t('eLeave.Sender')"
                  :rules="rules.requiredField"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.name"
                  :label="$t('TrainingClient.Identity.name')"
                  :rules="rules.requiredField"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.position"
                  :label="$t('Subsidy.CategoryOrCareer')"
                  :rules="rules.requiredField"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.department"
                  :label="$t('Subsidy.Subunit')"
                  :rules="rules.requiredField"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col
                id="startDate1"
                cols="4"
                md="5"
              >
                <s-date-picker
                  v-model="form.startDate1"
                  show-leave
                  clearable
                  class="text-body-2 text-sm-body-1"
                  :label="`${$t('eLeave.StartDate')} (1)`"
                />
              </v-col>

              <v-col
                cols="4"
                md="5"
              >
                <s-date-picker
                  v-model="form.endDate1"
                  show-leave
                  clearable
                  class="text-body-2 text-sm-body-1"
                  :label="`${$t('eLeave.EndDate')} (1)`"
                />
              </v-col>
              <v-col
                cols="4"
                md="2"
              >
                <v-text-field
                  v-model="form.days1"
                  :label="`${$t('eLeave.ALDays')} (1)`"
                  readonly
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col
                id="startDate2"
                cols="4"
                md="5"
              >
                <s-date-picker
                  v-model="form.startDate2"
                  show-leave
                  clearable
                  class="text-body-2 text-sm-body-1"
                  :label="`${$t('eLeave.StartDate')} (2)`"
                />
              </v-col>

              <v-col
                cols="4"
                md="5"
              >
                <s-date-picker
                  v-model="form.endDate2"
                  show-leave
                  clearable
                  class="text-body-2 text-sm-body-1"
                  :label="`${$t('eLeave.EndDate')} (2)`"
                />
              </v-col>
              <v-col
                cols="4"
                md="2"
              >
                <v-text-field
                  v-model="form.days2"
                  :label="`${$t('eLeave.ALDays')} (2)`"
                  readonly
                />
              </v-col>
            </v-row>
            <v-checkbox
              v-model="form.feriasTypePlanned"
              :disabled="feriasTypePlannedDisabled"
              :label="$t('eLeave.MatchMapa')"
              hide-details
            />
            <v-checkbox
              v-if="entityConfig && leaveStat && leaveStat.holidayRightStatus > 0 && (entityConfig.maxEarlyLeaveDayBelowOneYear > 0 || entityConfig.maxYearlyEarlyLeaveDayOverOneYear > 0)"
              v-model="form.feriasTypeUseNextYear"
              :disabled="feriasTypeUseNextYearDisabled"
              :label="`${$t('eLeave.PreTakeNextYearAL')}${$t('eLeave.OrSupplementLeave')}`"
              hide-details
            />
            <v-scroll-y-transition
              v-if="entityConfig && leaveStat && leaveStat.holidayRightStatus > 0 && (entityConfig.maxEarlyLeaveDayBelowOneYear > 0 || entityConfig.maxYearlyEarlyLeaveDayOverOneYear > 0)"
            >
              <v-radio-group
                v-show="form.feriasTypeUseNextYear"
                v-model="form.serveOver1Year"
                class="ml-6"
                row
              >
                <v-radio
                  v-if="leaveStat && entityConfig && entityConfig.maxEarlyLeaveDayBelowOneYear > 0 && leaveStat.holidayRightStatus === 1"
                  :label="$t('eLeave.ServeLessThanOneYear')"
                  value="false"
                />

                <v-radio
                  v-if="leaveStat && entityConfig && entityConfig.maxYearlyEarlyLeaveDayOverOneYear > 0 && leaveStat.holidayRightStatus === 2"
                  :label="$t('eLeave.ServeMoreThanOneYear')"
                  value="true"
                />
              </v-radio-group>
            </v-scroll-y-transition>
            <v-checkbox
              v-model="form.feriasTypeUnplanned"
              :disabled="feriasTypeUnplannedDisabled"
              :label="$t('eLeave.NotRegisteredAL')"
              hide-details
            />
            <v-checkbox
              v-model="form.feriasTypeChangePlan"
              :disabled="feriasTypeChangePlanDisabled"
              :label="$t('eLeave.ChangeAL')"
              hide-details
            />

            <v-scroll-y-transition>
              <div v-show="form.feriasTypeChangePlan">
                <v-row dense>
                  <v-col
                    cols="5"
                    class="ml-4"
                  >
                    <s-date-picker
                      v-model="form.changeStartDate1"
                      class="text-body-2 text-sm-body-1"
                      :label="`${$t('eLeave.StartDate')} (1)`"
                      clearable
                    />
                  </v-col>

                  <v-col
                    cols="5"
                  >
                    <s-date-picker
                      v-model="form.changeEndDate1"
                      class="text-body-2 text-sm-body-1"
                      :label="`${$t('eLeave.EndDate')} (1)`"
                      clearable
                    />
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col
                    cols="5"
                    class="ml-4"
                  >
                    <s-date-picker
                      v-model="form.changeStartDate2"
                      class="text-body-2 text-sm-body-1"
                      :label="`${$t('eLeave.StartDate')} (2)`"
                      clearable
                    />
                  </v-col>

                  <v-col
                    cols="5"
                  >
                    <s-date-picker
                      v-model="form.changeEndDate2"
                      class="text-body-2 text-sm-body-1"
                      :label="`${$t('eLeave.EndDate')} (2)`"
                      clearable
                    />
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col
                    cols="5"
                    class="ml-4"
                  >
                    <s-date-picker
                      v-model="form.changeStartDate3"
                      class="text-body-2 text-sm-body-1"
                      :label="`${$t('eLeave.StartDate')} (3)`"
                      clearable
                    />
                  </v-col>

                  <v-col
                    cols="5"
                  >
                    <s-date-picker
                      v-model="form.changeEndDate3"
                      class="text-body-2 text-sm-body-1"
                      :label="`${$t('eLeave.EndDate')} (3)`"
                      clearable
                    />
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col
                    cols="10"
                    class="ml-4"
                  >
                    <v-text-field
                      v-model="form.changePlanReason"
                      :label="$t('TrainingClient.Reason')"
                    />
                  </v-col>
                </v-row>
              </div>
            </v-scroll-y-transition>

            <!-- <v-checkbox
              v-model="form.claimNoLongFerias"
              :disabled="claimNoLongFeriasDisabled"
              :label="$t('eLeave.CannotClaim10Days')"
              hide-details
            /> -->

            <br>

            <p class="grey--text text--darken-3">
              {{ $t('eLeave.ContactClaim') }}
            </p>
            <v-checkbox
              v-model="form.stayMacau"
              :label="$t('eLeave.StayMacau')"
              hide-details
            />
            <v-scroll-y-transition>
              <v-textarea
                v-show="form.stayMacau"
                v-model="form.stayMacauContact"
                rows="2"
                hide-details
              />
            </v-scroll-y-transition>
            <v-checkbox
              v-model="form.goOut"
              :label="$t('eLeave.LeaveMacau')"
              hide-details
            />
            <v-scroll-y-transition>
              <v-textarea
                v-show="form.goOut"
                v-model="form.goOutContact"
                rows="2"
                hide-details
              />
            </v-scroll-y-transition>

            <br>

            <s-search-staff
              :select.sync="form.assignedToEuid"
              :staff.sync="toStaffObj"
              :label="$t('Training.SubmitTarget')"
              show-group
            />

            <br>

            <v-btn
              :loading="loading"
              color="primary"
              class="mr-2"
              @click="showingConfirmDialog = true"
            >
              {{ $t('Text.Submit') }}
            </v-btn>

            <s-confirm-dialog
              v-model="showingConfirmDialog"
              :message="$t('eLeave.SubmitConfirmation')"
              :true-label="$t('ConfirmModal.OK')"
              :false-label="$t('Text.Cancel')"
              @confirm="submit"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
            class="gray-list hidden-sm-and-down"
          >
            <s-mapa-records @mapaClick="mapaClickHandler" />
          </v-col>
        </v-row>
        <br><br>
      </v-form>
    </v-card>
    <s-bottom-sheet
      :title="$t('eleave.mapaNotUsed')"
      class="hidden-md-and-up"
    >
      <s-mapa-records @mapaClick="mapaClickHandler" />
    </s-bottom-sheet>
  </v-container>
</template>

<style scoped>
  .gray-list .theme--light.v-list {
    background: #F5F5F5;
  }
</style>

<script>
import SDatePicker from '../../components/SDatePicker'
import SBottomSheet from '../../components/SBottomSheet'
import SSearchStaff from '../../components/SSearchStaff'
import SConfirmDialog from '@/components/SConfirmDialog'
import SMapaRecords from './components/SMapaRecords'
// import pubHolidayApi from '../../api/hr/publicHoliday'
import { mapState } from 'vuex'
import _ from 'lodash'
import store from '../../store'
import { staffModule, eLeaveModule, codeTableModule, globalModule } from '../../store/moduleName'
import eLeave from '../../store/modules/leave/eLeave'
import eLeaveApi from '../../api/leave/eLeave'
import { ID_SIGN_COMPLETE_CB_URL, LOADING_TIMEOUT, BUSINESS_CODE } from '../../constant/constant'
import signHelper from '../../helper/signHelper'
import codeTable from '../../store/modules/hr/codeTable'
import { eLeaveMethod } from '@/views/Eleave/mixins/eLeaveMethod'

import VuetifyJetValidator from 'vuetify-jet-validator'
import { mdiArrowLeft } from '@mdi/js'

if (!store.state[codeTableModule]) store.registerModule(codeTableModule, codeTable)
if (!store.state[eLeaveModule]) store.registerModule(eLeaveModule, eLeave)

export default {
  components: {
    SDatePicker,
    SMapaRecords,
    SSearchStaff,
    SBottomSheet,
    SConfirmDialog
  },
  mixins: [eLeaveMethod],
  data: function () {
    const validator = new VuetifyJetValidator()
    return {
      mdiArrowLeft: mdiArrowLeft,
      form: {
        approver: this.$t('Subsidy.DirectorOrSubdirector'),
        name: null,
        callbackUrl: null,
        position: null,
        department: null,
        days1: null,
        startDate1: null,
        endDate1: null,
        days2: null,
        startDate2: null,
        endDate2: null,
        feriasTypePlanned: false,
        feriasTypeUseNextYear: false,
        feriasTypeUnplanned: false,
        feriasTypeChangePlan: false,
        // claimNoLongFerias: false,
        stayMacau: false,
        stayMacauContact: null,
        // serveOver1Year: 'true',
        serveOver1Year: null,
        goOut: false,
        goOutContact: null,
        assignedToEuid: null,
        assignedToGroupId: null,
        changePlanReason: null,
        changeStartDate1: null,
        changeEndDate1: null,
        changeStartDate2: null,
        changeEndDate2: null,
        changeStartDate3: null,
        changeEndDate3: null
      },
      feriasTypePlannedDisabled: false,
      feriasTypeUseNextYearDisabled: false,
      feriasTypeUnplannedDisabled: false,
      feriasTypeChangePlanDisabled: false,
      // claimNoLongFeriasDisabled: false,
      loading: false,
      showingConfirmDialog: false,
      toStaffObj: null,
      rules: {
        requiredField: [
          validator.rules.required(this.$t('TrainingClient.RequiredField'))
        ]
      }
    }
  },
  computed: {
    ...mapState({
      staff: state => state[staffModule].info,
      appraiser: state => state[staffModule].appraiser,
      feriasForm: state => state[eLeaveModule].feriasForm,
      entityConfig: state => state[eLeaveModule].entityConfig,
      leaveStat: state => state[eLeaveModule].leaveStat
    })
  },
  watch: {
    'form.feriasTypeUseNextYear': function (val) {
      if (val) {
        this.form.feriasTypePlanned = false
        this.form.feriasTypeUnplanned = false
        this.form.feriasTypeChangePlan = false
        // this.form.claimNoLongFerias = false
      }

      this.feriasTypePlannedDisabled = val
      this.feriasTypeUnplannedDisabled = val
      this.feriasTypeChangePlanDisabled = val
      // this.claimNoLongFeriasDisabled = val
    },
    // 'form.claimNoLongFerias': function (val) {
    //   if (val) {
    //     this.form.feriasTypePlanned = false
    //     this.form.feriasTypeUseNextYear = false
    //     this.form.feriasTypeUnplanned = false
    //     this.form.feriasTypeChangePlan = false
    //     this.form.startDate1 = null
    //     this.form.endDate1 = null
    //     this.form.startDate2 = null
    //     this.form.endDate2 = null
    //   }

    //   this.feriasTypePlannedDisabled = val
    //   this.feriasTypeUseNextYearDisabled = val
    //   this.feriasTypeUnplannedDisabled = val
    //   this.feriasTypeChangePlanDisabled = val
    // },
    'form.startDate1': function (val) {
      this.debounceCalDays1()
      if (!this.form.endDate1 || this.form.endDate1 < val) {
        this.form.endDate1 = val
      }
    },
    'form.endDate1': function (val) {
      this.debounceCalDays1()
    },
    'form.startDate2': function (val) {
      this.debounceCalDays2()
      if (!this.form.endDate2 || this.form.endDate2 < val) {
        this.form.endDate2 = val
      }
    },
    'form.endDate2': function () {
      this.debounceCalDays2()
      // this.calDays2()
    },
    'form.feriasTypeChangePlan': function (val) {
      if (!val) {
        this.form.changePlanReason = null
        this.form.changeStartDate1 = null
        this.form.changeStartDate2 = null
        this.form.changeStartDate3 = null
        this.form.changeEndDate1 = null
        this.form.changeEndDate2 = null
        this.form.changeEndDate3 = null
      }
    },
    'form.changeStartDate1': function (val) {
      if (!this.form.changeEndDate1 || this.form.changeEndDate1 < val) {
        this.form.changeEndDate1 = val
      }
    },
    'form.changeStartDate2': function (val) {
      if (!this.form.changeEndDate2 || this.form.changeEndDate2 < val) {
        this.form.changeEndDate2 = val
      }
    },
    'form.changeStartDate3': function (val) {
      if (!this.form.changeEndDate3 || this.form.changeEndDate3 < val) {
        this.form.changeEndDate3 = val
      }
    }
  },
  mounted () {
    // this.arrayHolidays = [...Array(6)].map(() => {
    //   const day = Math.floor(Math.random() * 30)
    //   const d = new Date()
    //   d.setDate(day)
    //   return d.toISOString().substr(0, 10)
    // })
  },
  async created () {
    let currentYear = (new Date()).getFullYear()
    if (!this.entityConfig) {
      this.$store.dispatch(eLeaveModule + '/getEntityConfig')
    }
    if (!this.leaveStat || !this.leaveStat.year) {
      this.$store.dispatch(eLeaveModule + '/getLeaveStat', currentYear)
    }
    if (!this.staff) {
      await this.$store.dispatch(staffModule + '/getStaff')
    }
    if (!this.$store.state[codeTableModule].pubHolidays || !this.$store.state[codeTableModule].pubHolidays.length) {
      await this.$store.dispatch(codeTableModule + '/getPubHolidays')
    }
    this.debounceCalDays1 = _.debounce(this.calDays1, 300)
    this.debounceCalDays2 = _.debounce(this.calDays2, 300)
    this.form.name = this.$chPtObjData('chinName', this.staff)
    if (this.staff.officialTypeChinTitle) {
      this.form.position = this.$chPtObjData('officialTypeChinTitle', this.staff)
    } else {
      this.form.position = this.$chPtObjData('careerChinDesc', this.staff)
    }
    this.form.department = this.$chPtObjData('subunitChinName', this.staff)
    // this.form.assignedToEuid = this.staff.defaultNextEuid
    this.form.assignedToEuid = this.appraiser.euid

    if (this.leaveStat && this.leaveStat.holidayRightStatus === 1) { //    1 > serveYear >= 1/2
      this.form.feriasTypeUseNextYear = true
      this.form.serveOver1Year = 'false'
    }
    if (this.leaveStat && this.leaveStat.holidayRightStatus === 2) {
      this.form.serveOver1Year = 'true'
    }
    this.setApproverByLastFormMetas(this.form, BUSINESS_CODE.ELEAVE_FERIAS)
  },
  methods: {
    mapaClickHandler: function (mapa) {
      // startDate & endDate both null => fill both
      // only endDate null => fill endDate
      if (!this.form.startDate1 && !this.form.endDate1) {
        this.form.startDate1 = mapa.startDate
        this.form.endDate1 = mapa.endDate
        this.$vuetify.goTo('#startDate1')
        this.$store.dispatch('global/setSnackbarMsg', this.$t('eLeave.Msg.StartEndDayAlreadyFilled', [1]))
      } else if (!this.form.endDate1) {
        this.form.endDate1 = mapa.endDate
        this.$vuetify.goTo('#startDate1')
        this.$store.dispatch('global/setSnackbarMsg', this.$t('eLeave.Msg.EndDayAlreadyFilled', [1]))
      } else if (!this.form.startDate2 && !this.form.endDate2) {
        this.form.startDate2 = mapa.startDate
        this.form.endDate2 = mapa.endDate
        this.$vuetify.goTo('#startDate2')
        this.$store.dispatch('global/setSnackbarMsg', this.$t('eLeave.Msg.StartEndDayAlreadyFilled', [2]))
      } else if (!this.form.endDate2) {
        this.form.endDate2 = mapa.endDate
        this.$vuetify.goTo('#startDate2')
        this.$store.dispatch('global/setSnackbarMsg', this.$t('eLeave.Msg.EndDayAlreadyFilled', [2]))
      } else {
        this.$store.dispatch('global/setSnackbarMsg', this.$t('eLeave.Error.CannotFillStartEndDate'))
      }
    },
    calDays1: function () {
      if (this.form.startDate1 && this.form.endDate1) {
        // pubHolidayApi.getWorkingDays(workingDays => {
        //   this.form.days1 = workingDays
        // }, this.form.startDate1, this.form.endDate1)
        eLeaveApi.getWorkingDays(this.form.startDate1, this.form.endDate1, resp => {
          this.form.days1 = resp
        })
      }
    },
    calDays2: function () {
      if (this.form.startDate2 && this.form.endDate2) {
        // pubHolidayApi.getWorkingDays(workingDays => {
        //   this.form.days2 = workingDays
        // }, this.form.startDate2, this.form.endDate2)
        eLeaveApi.getWorkingDays(this.form.startDate2, this.form.endDate2, resp => {
          this.form.days2 = resp
        })
      } else if (this.form.days2) {
        this.form.days2 = null
      }
    },
    submit: function () {
      this.loading = true
      if (!this.$refs.feriasForm.validate()) {
        this.loading = false
        return false
      }
      if (this.form.feriasTypeChangePlan) {
        if (this.form.changeStartDate1 && !this.form.changeEndDate1) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('eLeave.EndDate')]) + ' (1)')
          this.loading = false
          return false
        } else if (!this.form.changeStartDate1 && this.form.changeEndDate1) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('eLeave.StartDate')]) + ' (1)')
          this.loading = false
          return false
        }
        if (this.form.changeStartDate2 && !this.form.changeEndDate2) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('eLeave.EndDate')]) + ' (2)')
          this.loading = false
          return false
        } else if (!this.form.changeStartDate2 && this.form.changeEndDate2) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('eLeave.StartDate')]) + ' (2)')
          this.loading = false
          return false
        }
        if (this.form.changeStartDate3 && !this.form.changeEndDate3) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('eLeave.EndDate')]) + ' (3)')
          this.loading = false
          return false
        } else if (!this.form.changeStartDate3 && this.form.changeEndDate3) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('eLeave.StartDate')]) + ' (3)')
          this.loading = false
          return false
        }
      }
      if (this.toStaffObj && this.toStaffObj.definedGroupId) {
        this.form.assignedToEuid = null
        this.form.assignedToGroupId = this.toStaffObj.definedGroupId
      }
      if (!this.form.assignedToEuid && !this.form.assignedToGroupId) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('TrainingClient.ChooseSubmitTarget'))
        this.loading = false
        return false
      }
      this.form.callbackUrl = ID_SIGN_COMPLETE_CB_URL
      this.$store.dispatch(eLeaveModule + '/assignFeriasForm', this.form)
      let finalForm = JSON.stringify(this.feriasForm)
      let signObj = {}
      signObj[signHelper.GET_SIGN_LINK_URL] = eLeaveApi.feriasGetSignLinkUrl
      signObj[signHelper.SIGN_AND_START_WORKFLOW_URL] = eLeaveApi.feriasSignAndStartWorkflowUrl
      signObj[signHelper.REDIRECT_PATH] = '/eleave/list'
      signObj[signHelper.POST_FORM] = finalForm
      signObj[signHelper.SUCCESS_MSG_KEY] = 'TrainingClient.SaveSuccess'
      signObj[signHelper.FAIL_MSG_KEY] = 'Subsidy.AppForm.FailMessage'

      signHelper.signAndStartWorkflow(signObj)
      setTimeout(() => {
        this.loading = false
      }, LOADING_TIMEOUT)
    }
  }
}
</script>
